import {
  getOrderData,
  getOrderDataByRegion,
  OrderData,
  OrderDataRegion,
  RangeType
} from 'api/dashboard/_request';
import EcomTopRegionsTable from 'components/tables/EcomTopRegionsTable';
import React, { useEffect, useState } from 'react';

const EcomTopRegions = ({ orderData }: { orderData?: OrderDataRegion[] }) => {
  return (
    <>
      <div className="mb-5 mt-7">
        <h3> Top regions by revenue</h3>
        <p className="text-body-tertiary">
          {' '}
          Where you generated most of the revenue
        </p>
      </div>
      <EcomTopRegionsTable data={orderData} />
    </>
  );
};

export default EcomTopRegions;
